import { Component, computed, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { FeatureFlagState } from '@app/state/feature-flags/store/feature-flag.state';
import { LayoutContextService } from '../../layout-context.service';
import { FooterBrandedComponent } from './variants/footer-branded/footer-branded.component';
import { FooterCleanComponent } from './variants/footer-clean/footer-clean.component';
import { FooterSimpleComponent } from './variants/footer-simple/footer-simple.component';
import { FooterMinimalComponent } from './variants/footer-minimal/footer-minimal.component';
import { FooterPlatformComponent } from './variants/footer-platform/footer-platform.component';

@Component({
  selector: 'gb-footer',
  standalone: true,
  imports: [
    FooterBrandedComponent,
    FooterCleanComponent,
    FooterSimpleComponent,
    FooterMinimalComponent,
    FooterPlatformComponent,
  ],
  template: `
    @if (ctx().route.footerEnabled && !checkoutFooterHidden()) {
      @switch (ctx().slots.footer) {
        @case ('platform') {
          <gb-footer-platform [ctx]="ctx()" />
        }
        @case ('branded') {
          <gb-footer-branded [ctx]="ctx()" />
        }
        @case ('clean') {
          <gb-footer-clean [ctx]="ctx()" />
        }
        @case ('simple') {
          <gb-footer-simple [ctx]="ctx()" />
        }
        @case ('minimal') {
          <gb-footer-minimal [ctx]="ctx()" />
        }
        @default {
          <gb-footer-simple [ctx]="ctx()" />
        }
      }
    }
  `,
})
export class FooterHostComponent {
  protected readonly ctx = inject(LayoutContextService).context;

  private readonly hideFooterFlag = inject(Store).selectSignal(
    FeatureFlagState.isEnabled('checkout_hide_footer')
  );

  /**
   * `slots.footer === 'minimal'` is checkout-exclusive today — the `/checkout`
   * route is the only one that sets `footerSlot: 'minimal'` (see
   * `app-routing.module.ts`) — so it doubles as the "this is checkout" check
   * without adding a second route-detection mechanism.
   */
  protected readonly checkoutFooterHidden = computed(
    () => this.hideFooterFlag() && this.ctx().slots.footer === 'minimal'
  );
}
